export default "__VITE_PUBLIC_ASSET__ba761a9b__"